import Fonts from '../constants/Fonts';

export default function useGetFontSize(type: keyof typeof Fonts): number {
  return Fonts[type];
}
